import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {MasterDataSetBO} from "./MasterDataSetBO";
import {WB_MasterDataSetRow, WB_SalesAreaRow, WB_SetsRow, WB_SourceRow} from "../PA.Core/PAdbSchemaRows";
import {ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_MasterData_Set, esWB_Set, esWB_Source, esWB_Source_SetType} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";

const KeySetStoreGroups = [
    ['Product', 'ConsumerProduct'],
    ['ProductGroup', 'Brand','Category'],
    ['Customer', 'Vendor'],
    ['ERP'],
    ['Circular']
]

function isEmptyTrim(a: any): boolean {
    if(_.isEmpty(a))
        return true
    if(_.isString(a))
        return _.isEmpty(a.trim())
    return false
}

export class MasterDataSetBOValidations {


    static async Validate(aBO: MasterDataSetBO): Promise<void> {
        aBO.ValidateMessageProvider.clearMessages()

        await MasterDataSetBOValidations.ValidateMDSetId(aBO)

        await MasterDataSetBOValidations.ValidateActivation(aBO)

        await MasterDataSetBOValidations.ValidateEnterpriseStructure(aBO)
    }

    static async ValidateEnterpriseStructure(aBO: MasterDataSetBO): Promise<void> {

        //-- 1. Validate Blank IDs
        await MasterDataSetBOValidations.ValidateEnterpriseStructureBlanks(aBO)

        //-- 2. Validate Duplicate IDs
        await MasterDataSetBOValidations.ValidateEnterpriseSetupDuplicateIds(aBO)

        // 3. Validate Sales Areas
        await MasterDataSetBOValidations.ValidateEnterpriseSalesAreas(aBO)
    }

    static async ValidateActivation(aBO: MasterDataSetBO): Promise<void> {

        //-- 1. Validate Blank IDs
        await MasterDataSetBOValidations.ValidateSourceKeySetBlanks(aBO)

        //-- Validate Duplicate MDSet Ids
        await MasterDataSetBOValidations.ValidateSourceKeysetDuplicateIds(aBO)

        //-- 3. Validate DataSource Duplicate IDs
        //-- a. Internal
        //-- b. External
        await MasterDataSetBOValidations.ValidateDataSourceDuplicateIds(aBO)

        //-- 4. Validate KeySet Duplicate IDs
        //-- a. Internal
        //-- b. External
        await MasterDataSetBOValidations.ValidateKeySetDuplicateIds(aBO)


    }

    static async ValidateMDSetId(aBO: MasterDataSetBO): Promise<void> {
        //--
        let mdSetId = aBO.WB_MasterDataSet.cif.MDSET_ID
        let mdSetName = aBO.WB_MasterDataSet.cif.MDSET_NAME
        if(isEmptyTrim(mdSetId))
            return

        let aDupIds =<WB_MasterDataSetRow[]> await aBO.dbContext.findAll(esWB_MasterData_Set, {
            where: {
                MDSET_ID: mdSetId,
                WB_MDSET_ID: {neq: aBO.WB_MasterDataSet.cif.WB_MDSET_ID},
                DELETED_IND: {neq: '1'}
            }
        })

        if(aDupIds.length){
            let msg = `Master Data Set Id (${mdSetId}) overlaps ${aDupIds.map(a => a.cif.MDSET_NAME).join(", ")}`
            aBO.ValidateMessageProvider.addMessage({
                code: `MDSetIdOverlap`,
                type: MessageType.Error,
                title: msg, description: msg
            })
        }

    }

    static async ValidateSourceKeySetBlanks(aBO: MasterDataSetBO): Promise<void> {

        let mdSetId = aBO.WB_MasterDataSet.cif.MDSET_ID
        let mdSetName = aBO.WB_MasterDataSet.cif.MDSET_NAME

        if(isEmptyTrim(mdSetId)){
            let msg = `Master Data Set Id Empty`
            aBO.ValidateMessageProvider.addMessage({
                code: `NoMDSetId`,
                type: MessageType.Error,
                title: msg, description: msg
            })
        }

        if(isEmptyTrim(mdSetName)){
            let msg = `Master Data Set Name Empty`
            aBO.ValidateMessageProvider.addMessage({
                code: `NoMDSetName`,
                type: MessageType.Error,
                title: msg, description: msg
            })
        }

        _.forEach(aBO.WB_MasterDataSet.WB_SourceRows, (aSourceRow) => {
            if(!aSourceRow.isActive)
                return

            if(isEmptyTrim(aSourceRow.cif.SOURCE_ID)) {
                let msg = `Source Id Empty, (${aSourceRow.cif.SOURCE_NAME})`
                aBO.ValidateMessageProvider.addMessage({
                    code: `NoId-${aSourceRow.cif.WB_SOURCE_ID}`,
                    type: MessageType.Error,
                    title: msg, description: msg
                })
            }

            if(isEmptyTrim(aSourceRow.cif.SOURCE_NAME)) {
                let msg = `Source Name Empty, (${aSourceRow.cif.SOURCE_ID})`
                aBO.ValidateMessageProvider.addMessage({
                    code: `NoName-${aSourceRow.cif.WB_SOURCE_ID}`,
                    type: MessageType.Warning,
                    title: msg, description: msg
                })
            }

        })

        //-- Key Sets
        _.forEach(aBO.WB_MasterDataSet.WB_SetsRows, (aSetsRow) => {
            if(!aSetsRow.isActive)
                return

            if(isEmptyTrim(aSetsRow.cif.SET_ID)) {
                let msg = `Key Set Id Empty, (${aSetsRow.cif.SET_NAME})`
                aBO.ValidateMessageProvider.addMessage({
                    code: `NoSetId-${aSetsRow.cif.WB_SET_ID}`,
                    type: MessageType.Error,
                    title: msg, description: msg
                })
            }

            if(isEmptyTrim(aSetsRow.cif.SET_NAME)) {
                let msg = `Key Set Name Empty, (${aSetsRow.cif.SET_ID})`
                aBO.ValidateMessageProvider.addMessage({
                    code: `NoSetName-${aSetsRow.cif.WB_SET_ID}`,
                    type: MessageType.Warning,
                    title: msg, description: msg
                })
            }

        })


    }

    static async ValidateEnterpriseSetupDuplicateIds(aBO: MasterDataSetBO): Promise<void> {


        function validateDupIds(arrRecord: ESRecord[], name: string, idField: string, nameField: string, setField: string, idName?: string){
            let dct: {[keySetId: string]: {[id:string]: ESRecord[]}} = {}
            _.forEach(arrRecord, (aRow) => {
                if(!aRow.isActive)
                    return

                let id = (<any>aRow)[idField]
                let set_id = (<any>aRow)[setField]
                if(isEmptyTrim(id) || isEmptyTrim(set_id))
                    return

                if(!(set_id in dct))
                    dct[set_id] = {}

                if(id in dct[set_id])
                    dct[set_id][id].push(aRow)
                else
                    dct[set_id][id] = [aRow]
            })

            // Create Duplicate Id Errors
            _.forEach(dct, (dctById, set_id) => {
                _.forEach(dctById, (arr, id) => {
                    if(arr.length > 1){
                        let msg = `${name} ${idName|| 'Id'} (${id}/${set_id}) is Duplicated in ${arr.length} , (${_.map(arr, (a) => (<any>a)[nameField]).join(", ")})`
                        aBO.ValidateMessageProvider.addMessage({
                            code: `Dup-${name}-${id}`,
                            type: MessageType.Error,
                            title: msg, description: msg
                        })
                    }
                })
            })
        }

        // Division, DistribChannel, Company, SalesOrg
        validateDupIds(aBO.WB_MasterDataSet.WB_DivisionRows, "Division", "DIVISION_ID", "DIVISION_NAME", "ENTERPRISE_SET_ID")
        validateDupIds(aBO.WB_MasterDataSet.WB_DistribChannelRows, "Distribution Channel", "DISTRIBCHANNEL_ID", "DISTRIBCHANNEL_NAME", "ENTERPRISE_SET_ID")
        validateDupIds(aBO.WB_MasterDataSet.WB_CompanyRows, "Company", "COMPANY_ID", "COMPANY_NAME", "ENTERPRISE_SET_ID", 'Code')
        validateDupIds(aBO.SalesOrgs, "SalesOrg", "SALESORG_ID", "SALESORG_NAME", "ENTERPRISE_SET_ID")
        validateDupIds(aBO.SalesAreas, "SalesArea", "SALESAREA_ID", "SALESAREA_NAME", "ENTERPRISE_SET_ID")

    }

    static async ValidateEnterpriseSalesAreas(aBO: MasterDataSetBO): Promise<void> {
        let arrSalesOrg = _.filter(_.flatMap(aBO.WB_MasterDataSet.WB_CompanyRows, (a) => a.WB_SalesOrgRows), (b) => b.isActive)
        let arrSalesArea = _.filter(_.flatMap(arrSalesOrg, (a) => a.WB_SalesAreaRows), (b) => b.isActive)

        let dctSA: {[soId: number]: {[dvId: number]: {[dcId: number]: WB_SalesAreaRow}}} = {}


        _.forEach(arrSalesArea, (aSalesArea) => {
            //--
            let wbSOId = aSalesArea.cif.WB_SALESORG_ID
            let wbDVId = aSalesArea.cif.WB_DIVISION_ID
            let wbDCId = aSalesArea.cif.WB_DISTRIBCHANNEL_ID
            if(aSalesArea.isActive && (wbSOId)  && (wbDVId) && (wbDCId)){
                // Place in Dictionary
                if(!(wbSOId in dctSA))
                    dctSA[wbSOId] = {}
                if(!(wbDVId in dctSA[wbSOId]))
                    dctSA[wbSOId][wbDVId] = {}
                if(!(wbDCId in dctSA[wbSOId][wbDVId]))
                    dctSA[wbSOId][wbDVId][wbDCId] = aSalesArea
                else {
                    let exSA = dctSA[wbSOId][wbDVId][wbDCId]
                    // report Overlap
                    let msg = `Sales Areas: ${aSalesArea.cif.SALESAREA_NAME} (${exSA.cif.SALESAREA_ID}), ${exSA.cif.SALESAREA_NAME} (${aSalesArea.cif.SALESAREA_ID}) have Overlapping SalesOrg, Division, Distribution Channel`
                    aBO.ValidateMessageProvider.addMessage({
                        code: `SA-${aSalesArea.cif.WB_SALESAREA_ID}-${exSA.cif.WB_SALESAREA_ID}-Overlap`,
                        type: MessageType.Error,
                        title: msg, description: msg
                    })
                }
            }


            if(!aSalesArea.bManualInd)
                return

            if(!(aSalesArea.cif.WB_DIVISION_ID > 0)){
                let msg = `Sales Area ${aSalesArea.cif.SALESAREA_NAME} (${aSalesArea.cif.SALESAREA_ID}) Division not set`
                aBO.ValidateMessageProvider.addMessage({
                    code: `SA-${aSalesArea.cif.WB_SALESAREA_ID}-NoDivision`,
                    type: MessageType.Error,
                    title: msg, description: msg
                })
            }

            if(!(aSalesArea.cif.WB_DISTRIBCHANNEL_ID > 0)){
                let msg = `Sales Area ${aSalesArea.cif.SALESAREA_NAME} (${aSalesArea.cif.SALESAREA_ID}) Distribution Channel not set`
                aBO.ValidateMessageProvider.addMessage({
                    code: `SA-${aSalesArea.cif.WB_SALESAREA_ID}-NoDistribChannel`,
                    type: MessageType.Error,
                    title: msg, description: msg
                })
            }

        })

    }

    static async ValidateEnterpriseStructureBlanks(aBO: MasterDataSetBO): Promise<void> {


        function validateBlankIds(arrRecord: ESRecord[], grpName: string, idField: string, nameField: string, setField: string, idName?: string){
            if(isEmptyTrim(arrRecord))
                return

            let pkField:string = _.first(arrRecord)._mapper().idAttribute

            _.forEach(arrRecord, (aRow) => {
                if(!aRow.isActive)
                    return


                let wbId = (<any>aRow)[pkField]
                let id = (<any>aRow)[idField]
                let name = isEmptyTrim(nameField)? id+'.': (<any>aRow)[nameField]
                let setId = (<any>aRow)[setField]

                if(isEmptyTrim(id)) {
                    let msg = `${grpName} ${idName || 'Id'} Empty, (${name})`
                    aBO.ValidateMessageProvider.addMessage({
                        code: `No${grpName}Id-${wbId}`,
                        type: MessageType.Error,
                        title: msg, description: msg
                    })
                }

                if(isEmptyTrim(name)) {
                    let msg = `${grpName} Name Empty, (${id})`
                    aBO.ValidateMessageProvider.addMessage({
                        code: `No${grpName}Name-${wbId}`,
                        type: MessageType.Warning,
                        title: msg, description: msg
                    })
                }

                if(isEmptyTrim(setId)) {
                    let msg = `${grpName} Key Set is Empty, (${name}, ${id})`
                    aBO.ValidateMessageProvider.addMessage({
                        code: `No${grpName}KeySet-${wbId}`,
                        type: MessageType.Error,
                        title: msg, description: msg
                    })
                }


            })

        }

        // Division, DistribChannel, Company, SalesOrg
        validateBlankIds(aBO.WB_MasterDataSet.WB_DivisionRows, "Division", "DIVISION_ID", "DIVISION_NAME", "ENTERPRISE_SET_ID")
        validateBlankIds(aBO.WB_MasterDataSet.WB_DistribChannelRows, "Distribution Channel", "DISTRIBCHANNEL_ID", "DISTRIBCHANNEL_NAME", "ENTERPRISE_SET_ID")
        validateBlankIds(aBO.WB_MasterDataSet.WB_CompanyRows, "Company", "COMPANY_ID", "COMPANY_NAME", "ENTERPRISE_SET_ID", "Code")
        let arrSalesOrg = _.filter(_.flatMap(aBO.WB_MasterDataSet.WB_CompanyRows, (a) => a.WB_SalesOrgRows), (b) => b.isActive)
        validateBlankIds(arrSalesOrg, "SalesOrg", "SALESORG_ID", "SALESORG_NAME", "ENTERPRISE_SET_ID")
        let arrSalesArea = _.filter(_.flatMap(arrSalesOrg, (a) => a.WB_SalesAreaRows), (b) => b.isActive)
        validateBlankIds(arrSalesArea, "Sales Area", "SALESAREA_ID", "","ENTERPRISE_SET_ID")

    }


    static async ValidateSourceKeysetDuplicateIds(aBO: MasterDataSetBO): Promise<void> {

        let wbMDSetId = aBO.WB_MasterDataSet.cif.WB_MDSET_ID
        let MDSetId = aBO.WB_MasterDataSet.cif.MDSET_ID

        if(isEmptyTrim(aBO.WB_MasterDataSet.cif.MDSET_ID))
            return

        let dbContext = new PAdbContext()
        let arrMDSetOverlap = <WB_MasterDataSetRow[]> await dbContext.findAll(esWB_MasterData_Set, {
            where: {
                MDSET_ID: MDSetId,
                DELETED_IND: {notIn: ['1']},
                WB_MDSET_ID: {neq: wbMDSetId}
            }
        })

        if(arrMDSetOverlap.length){
            let msg = `Master Data Set Id overlaps ${_.map(arrMDSetOverlap, a => a.cif.MDSET_NAME).join(", ")}`
            aBO.ValidateMessageProvider.addMessage({
                code: `MDSetIdOverlap`,
                type: MessageType.Error,
                title: msg, description: msg
            })

        }
    }

    static async ValidateDataSourceDuplicateIds(aBO: MasterDataSetBO): Promise<void> {

        //a. Internal Duplicates
        let dctId: {[id:string]: WB_SourceRow[]} = {}
        _.forEach(aBO.WB_MasterDataSet.WB_SourceRows, (aSourceRow) => {
            if(!aSourceRow.isActive)
                return

            let srcId = aSourceRow.cif.SOURCE_ID
            let srcName = aSourceRow.cif.SOURCE_NAME
            if(isEmptyTrim(srcId))
                return

            if(srcId in dctId)
                dctId[srcId].push(aSourceRow)
            else
                dctId[srcId] = [aSourceRow]

        })

        _.forEach(dctId, (value, id) => {
            if(value.length <= 1)
                return
            let msg = `Sources Id (${id}) duplicated in ${_.map(value, (a) => a.cif.SOURCE_NAME).join(",")}.`
            aBO.ValidateMessageProvider.addMessage({
                code: `DupSourceId-${id}`,
                type: MessageType.Error,
                title: msg, description: msg
            })
        })

        //b. External Duplicates
        let ids = _.keys(dctId)
        if(isEmptyTrim(ids))
            return

        let rr = new ESRecordResolver(new PAdbContext(), {
            dctExcludeHasManyNamedRelations: {
                [esWB_Source]: [esWB_Source_SetType]
            }
        })
        let condition = {where: {
                WB_MDSET_ID: {neq: aBO.WB_MasterDataSet.cif.WB_MDSET_ID},
                DELETED_IND: {neq: '1'}
            }}

        let arr = <WB_SourceRow[]> await rr.queryAllWithRelationships(esWB_Source, condition)
        arr = _.sortBy(arr, ['SOURCE_ID', 'SOURCE_NAME'])
        for(let anExtSourceRow of arr){
            let extSourceId = anExtSourceRow.cif.SOURCE_ID
            let extSourceName = anExtSourceRow.cif.SOURCE_NAME
            if(!(extSourceId in dctId))
                continue

            let extMDSetId = anExtSourceRow?.WB_MasterDataSetRow?.cif?.MDSET_ID || 'Legacy'
            let extMDSetName = anExtSourceRow?.WB_MasterDataSetRow?.cif?.MDSET_NAME || 'Legacy'


            let msg = `Source Id (${extSourceId}) overlaps (${extSourceName}) in external Master Data Set ${extMDSetName} (${extMDSetId}).`
            aBO.ValidateMessageProvider.addMessage({
                code: `DupExtSrcId-${extSourceId}`,
                type: MessageType.Error,
                title: msg, description: msg
            })


        }

    }

    static async ValidateKeySetDuplicateIds(aBO: MasterDataSetBO): Promise<void> {

        for (let groupSetTypes of KeySetStoreGroups) {
            let groupName = groupSetTypes.join("-")
            let groupSets = _.filter(aBO.WB_MasterDataSet.WB_SetsRows, (a) =>  a.isActive && _.includes(groupSetTypes, a.cif.SET_TYPE))

            //a. Internal Duplicates, By Storage Groups
            let dctId: { [id: string]: WB_SetsRow[] } = {}
            _.forEach(groupSets, (aSetRow) => {
                let setId = aSetRow.cif.SET_ID
                if (isEmptyTrim(setId))
                    return

                if (setId in dctId)
                    dctId[setId].push(aSetRow)
                else
                    dctId[setId] = [aSetRow]

            })

            _.forEach(dctId, (value, id) => {
                if (value.length <= 1)
                    return
                let msg = `Key Set Group (${groupName}) has Ket Set Id (${id}) duplicated in ${_.map(value, (a) => a.cif.SET_NAME).join(",")}.`
                aBO.ValidateMessageProvider.addMessage({
                    code: `DupSetId-${id}`,
                    type: MessageType.Error,
                    title: msg, description: msg
                })
            })

            //b. External Duplicates
            let ids = _.keys(dctId)
            if (isEmptyTrim(ids))
                continue

            let rr = new ESRecordResolver(new PAdbContext(), { })
            // Find Sets of Type, not in this MDSet, then check for duplicates
            let condition = {where: {
                                SET_TYPE: {inq: groupSetTypes},
                                WB_MDSET_ID: {neq: aBO.WB_MasterDataSet.cif.WB_MDSET_ID},
                                DELETED_IND: {neq: '1'}
            }}

            let arr = <WB_SetsRow[]> await rr.queryAllWithRelationships(esWB_Set, condition)

            _.forEach(arr, (anExternalSetRow) => {
                let extSetId = anExternalSetRow.cif.SET_ID
                if(!(extSetId in dctId))
                    return

                //--
                let extSetName = anExternalSetRow.cif.SET_NAME
                let extMDSetId = anExternalSetRow?.WB_MasterDataSetRow?.cif?.MDSET_ID || 'Legacy'
                let extMDSetName = anExternalSetRow?.WB_MasterDataSetRow?.cif?.MDSET_NAME || 'Legacy'

                let msg = `Key Set Group (${groupName}) has Ket Set Id (${extSetId}) overlaps set (${extSetName}) in external Master Data Set ${extMDSetName} (${extMDSetId}).`
                aBO.ValidateMessageProvider.addMessage({
                    code: `DupExtSetId-${extSetId}`,
                    type: MessageType.Error,
                    title: msg, description: msg
                })


            })

        } // Next Storage Group

    }

    static async ValidateDelete(aBO: MasterDataSetBO): Promise<void> {
        aBO.DeleteMessageProvider.clearMessages()

        // 1. Check if the KeySet is in use
        let ksUsed = _.filter(aBO.WB_MasterDataSet.WB_SetsRows, (a) => (a.isActive && (a.cif.USAGE_COUNT > 0)))
        _.forEach(ksUsed, (aRow) => {
            let msg = `Key Set Id (${aRow.cif.SET_ID}/${aRow.cif.SET_TYPE}) has ${aRow.cif.USAGE_COUNT} record(s).`
            aBO.DeleteMessageProvider.addMessage({
                code: `KeySetUsed-${aRow.cif.WB_SET_ID}`,
                type: MessageType.Error,
                title: msg, description: msg
            })
        })

        // Find any non-manual records, that can not be deleted via the UI
        let dctInterfacedRecNames: {[grpName:string]: string[]} = {}

        function findNonManualRecs(arrRecord: ESRecord[], grpName: string, idField: string, nameField: string, setField: string){
            if(isEmptyTrim(arrRecord))
                return

            let pkField:string = _.first(arrRecord)._mapper().idAttribute

            _.forEach(arrRecord, (aRow) => {
                if(!aRow.isActive)
                    return


                let wbId = (<any>aRow)[pkField]
                let id = (<any>aRow)[idField]
                let name = isEmptyTrim(nameField)? id+'.': (<any>aRow)[nameField]
                let setId = (<any>aRow)[setField]
                let manualInd = (<any>aRow).MANUAL_IND || ''

                if(manualInd != '1'){
                    let nameId = `${name}, ${id}/${setId}`
                    if(grpName in dctInterfacedRecNames)
                        dctInterfacedRecNames[grpName].push(nameId)
                    else
                        dctInterfacedRecNames[grpName] = [nameId]
                }

            })

        }

        // Division, DistribChannel, Company, SalesOrg, SalesArea
        findNonManualRecs(aBO.WB_MasterDataSet.WB_DivisionRows, "Division", "DIVISION_ID", "DIVISION_NAME", "ENTERPRISE_SET_ID")
        findNonManualRecs(aBO.WB_MasterDataSet.WB_DistribChannelRows, "Distribution Channel", "DISTRIBCHANNEL_ID", "DISTRIBCHANNEL_NAME", "ENTERPRISE_SET_ID")
        findNonManualRecs(aBO.WB_MasterDataSet.WB_CompanyRows, "Company", "COMPANY_ID", "COMPANY_NAME", "ENTERPRISE_SET_ID")
        let arrSalesOrg = _.filter(_.flatMap(aBO.WB_MasterDataSet.WB_CompanyRows, (a) => a.WB_SalesOrgRows), (b) => b.isActive)
        findNonManualRecs(arrSalesOrg, "SalesOrg", "SALESORG_ID", "SALESORG_NAME", "ENTERPRISE_SET_ID")
        let arrSalesArea = _.filter(_.flatMap(arrSalesOrg, (a) => a.WB_SalesAreaRows), (b) => b.isActive)
        findNonManualRecs(arrSalesArea, "Sales Area", "SALESAREA_ID", "","ENTERPRISE_SET_ID")

        _.forEach(dctInterfacedRecNames, (arr, grpName) => {
            let msg = `${grpName}, ${arr.length} interface record(s) exists,\n${arr.join(", \n")}`
            aBO.DeleteMessageProvider.addMessage({
                code: `InterfacedRecords-${grpName}`,
                type: MessageType.Error,
                title: msg, description: msg
            })
        })

    }

}